import cleanDeep from 'clean-deep';

/**
 * This simply sends a client error and additional metadata to a sveltekit backend route
 * that then takes care of unminifying the stack trace, adding metadata and then reporting
 * that payload to GCP error reporting.
 *
 * @param {Object} error
 * @param {string} url
 * @param {string} userAgent
 * @param {Object} [additionalInfo]
 * @returns {Promise<void>}
 */
export async function reportClientError(error, url, userAgent, additionalInfo) {
    try {
        // call sveltekit backend route that will receive the error report and handle uploading to GCP error reporting
        const response = await fetch('/backend/report-error', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                cleanDeep({
                    message: error.message,
                    // send minified stack and let backend handle unminification
                    stack: error.stack,
                    url: url,
                    userAgent: userAgent,
                    additionalInfo: additionalInfo,
                })
            ),
        });

        if (!response.ok) {
            console.error(`Failed to report client error: ${response.statusText || 'Unknown Error'}`);
        }
    } catch (e) {
        console.error(`Failed to report client error: ${e}`);
    }
}
